module.exports = __webpack_public_path__ + "media/audio2.1eb2c68b.wav";